import { Card, Statistic } from 'antd';
import { ArrowUpOutlined } from 'icons';
import { useCurrentUser, useEntryStatistics } from 'libs/hooks';
import { useState, useEffect, useRef } from 'react';

export type EntryStatisticsProps = {
  isPageLoading?: boolean;
};

const EntryStatistics = ({
  isPageLoading,
}: EntryStatisticsProps): React.ReactElement => {
  const [animationPhase, setAnimationPhase] = useState(0);
  const prevValueRef = useRef(0);
  const currentUser = useCurrentUser();
  const { totalEntriesFiled, isFeatureEnabled } = useEntryStatistics();

  // July 16, 2024 12:00 PM CST ( All Hands end time, info given by Ankit )
  const launchDate = new Date('2025-07-16T17:00:00.000Z');
  const currentDate = new Date();
  const isLaunched = currentDate >= launchDate;

  useEffect(() => {
    if (totalEntriesFiled > prevValueRef.current && prevValueRef.current > 0) {
      setAnimationPhase(1);
      setTimeout(() => setAnimationPhase(2), 300);
      setTimeout(() => setAnimationPhase(3), 350);
      setTimeout(() => setAnimationPhase(0), 400);
    }
    prevValueRef.current = totalEntriesFiled;
  }, [totalEntriesFiled]);

  return (
    <>
      {!isPageLoading && isFeatureEnabled && currentUser?.id && (
        <div
          style={{
            marginTop: '4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {isLaunched && (
            <Card bordered={false} size="small">
              <Statistic
                title="Total US Entries Filed"
                value={totalEntriesFiled}
                valueStyle={{ color: '#3f8600' }}
                prefix={
                  <ArrowUpOutlined
                    style={{
                      transform:
                        animationPhase === 1
                          ? 'translateY(-20px)'
                          : animationPhase === 2
                          ? 'translateY(20px)'
                          : animationPhase === 3
                          ? 'translateY(20px)'
                          : 'translateY(0px)',
                      opacity:
                        animationPhase === 1 || animationPhase === 2 ? 0 : 1,
                      transition:
                        animationPhase === 2
                          ? 'none'
                          : animationPhase === 3
                          ? 'none'
                          : 'transform 0.3s ease-out, opacity 0.2s ease-out',
                    }}
                  />
                }
              />
            </Card>
          )}
        </div>
      )}
    </>
  );
};

export default EntryStatistics;
